import React from "react";

export default function Toolbar({ onApplyMask, onAddLayer, onDeleteLayer, onUndo, onRedo }) {
  return (
    <header className="h-14 bg-white border-b flex items-center px-4">
      <div className="flex items-center gap-3">
        <button type="button" className="px-3 py-1 rounded border">Brush</button>
        <button type="button" className="px-3 py-1 rounded border">Eraser</button>
        <button type="button" className="px-3 py-1 rounded border">Select</button>
        <button type="button" className="px-3 py-1 rounded border" onClick={onApplyMask}>Mask</button>
        <button type="button" className="px-3 py-1 rounded border" onClick={onAddLayer}>Add Layer</button>
        <button type="button" className="px-3 py-1 rounded border" onClick={onDeleteLayer}>Delete Layer</button>
        <button type="button" className="px-3 py-1 rounded border" onClick={onUndo}>Undo</button>
        <button type="button" className="px-3 py-1 rounded border" onClick={onRedo}>Redo</button>
      </div>
    </header>
  );
}

